interface ProgressCircleProps {
  /** Progress percentage from 0 to 100. */
  progress: number;

  /** Size of the loader (default: 100). */
  size?: number;

  /** Width of the circle stroke (default: 10). */
  strokeWidth?: number;

  /** Fill color of the circle. */
  fillColor?: string;
}

export function ProgressCircle({ progress, fillColor }: ProgressCircleProps) {
  return (
    <div className="relative w-40 h-40">
      <svg className="w-full h-full" viewBox="0 0 100 100">
        <circle
          className="text-gray-200 stroke-current"
          strokeWidth={10}
          cx="50"
          cy="50"
          r="40"
          fill="transparent"
        ></circle>
        <circle
          className={`progress-ring__circle stroke-current text-${fillColor}`}
          strokeWidth={10}
          strokeLinecap="round"
          cx="50"
          cy="50"
          r="40"
          fill="transparent"
          strokeDasharray={251.2}
          strokeDashoffset={`calc(251.2px - (251.2px * ${progress}) / 100)`}
        ></circle>
        <text
          className="fill-neutral-800"
          x="52"
          y="54"
          textAnchor="middle"
          alignmentBaseline="middle"
        >
          {progress}%
        </text>
      </svg>
    </div>
  );
}
